import React from "react";

function PrivacyPolicy() {
  return (
    <div className="page-container">
      <h1 className="page-title">Privacy Policy</h1>

      <div className="page-content">
        <p>
          <strong>Last updated:</strong> June 19, 2025
        </p>

        <p>
          This Privacy Policy describes how Puck Stats ("we," "our," or "us")
          collects, uses, and protects your information when you use our mobile
          application (the "Service").
        </p>

        <h2 className="page-subtitle">Information We Collect</h2>

        <h3>Personal Information</h3>
        <p>
          When you use Puck Stats, we may collect the following types of
          personal information:
        </p>
        <ul>
          <li>Player name and profile information</li>
          <li>Hockey statistics and performance data</li>
          <li>Game records and match details</li>
          <li>Device information and usage analytics</li>
        </ul>

        <h3>Automatically Collected Information</h3>
        <p>
          We may automatically collect certain information about your device and
          usage of the Service, including:
        </p>
        <ul>
          <li>Device type and operating system</li>
          <li>App usage patterns and preferences</li>
          <li>Crash reports and error logs</li>
          <li>Performance metrics</li>
        </ul>

        <h2 className="page-subtitle">How We Use Your Information</h2>
        <p>We use the collected information for the following purposes:</p>
        <ul>
          <li>To provide and maintain our Service</li>
          <li>To track and display your hockey statistics</li>
          <li>To improve app functionality and user experience</li>
          <li>To analyze usage patterns and optimize performance</li>
          <li>To provide customer support</li>
          <li>To send important updates about the Service</li>
        </ul>

        <h2 className="page-subtitle">Data Storage and Security</h2>
        <p>
          We implement appropriate security measures to protect your personal
          information against unauthorized access, alteration, disclosure, or
          destruction. Your data is stored securely using industry-standard
          encryption and security practices.
        </p>

        <p>
          However, please note that no method of transmission over the internet
          or electronic storage is 100% secure, and we cannot guarantee absolute
          security.
        </p>

        <h2 className="page-subtitle">Data Sharing</h2>
        <p>
          We do not sell, trade, or otherwise transfer your personal information
          to third parties without your consent, except in the following
          circumstances:
        </p>
        <ul>
          <li>To comply with legal obligations</li>
          <li>To protect our rights and safety</li>
          <li>
            With service providers who assist in app functionality (under strict
            confidentiality agreements)
          </li>
          <li>
            In the event of a business merger or acquisition (with prior notice)
          </li>
        </ul>

        <h2 className="page-subtitle">Your Rights and Choices</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal data stored in the app</li>
          <li>Update or correct your information</li>
          <li>Delete your account and associated data</li>
          <li>Opt out of non-essential communications</li>
          <li>Request a copy of your data</li>
        </ul>

        <h2 className="page-subtitle">Children's Privacy</h2>
        <p>
          Our Service is not intended for children under 13 years of age. We do
          not knowingly collect personal information from children under 13. If
          you are a parent or guardian and believe your child has provided us
          with personal information, please contact us so we can take
          appropriate action.
        </p>

        <h2 className="page-subtitle">Analytics and Tracking</h2>
        <p>
          We may use third-party analytics services to help us understand how
          our Service is used. These services may collect information about your
          use of our Service and other apps and websites over time.
        </p>

        <h2 className="page-subtitle">Changes to This Privacy Policy</h2>
        <p>
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page and
          updating the "Last updated" date. You are advised to review this
          Privacy Policy periodically for any changes.
        </p>

        <h2 className="page-subtitle">Data Retention</h2>
        <p>
          We will retain your personal information only for as long as necessary
          to fulfill the purposes outlined in this Privacy Policy. When you
          delete your account, we will delete your personal data within 30 days,
          unless we are required to retain it for legal purposes.
        </p>

        <h2 className="page-subtitle">International Data Transfers</h2>
        <p>
          Your information may be transferred to and processed in countries
          other than your own. We ensure that such transfers comply with
          applicable data protection laws and that your information receives
          adequate protection.
        </p>

        <h2 className="page-subtitle">Contact Us</h2>

        <p>
          By using Puck Stats, you acknowledge that you have read and understood
          this Privacy Policy and agree to the collection, use, and disclosure
          of your information as described herein.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
